export default "__VITE_ASSET__BLNUQU_V__"